export default __webpack_public_path__ + "static/media/35.625b8fcc.jpg";